(ns app.front.view.workspace.phase-indicator
  (:require [app.front.ui.select :as ui-select]
            [app.front.view.workspace.primary-actions :as primary-actions]
            [app.front.view.workspace.util :as ws-util]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.front.media-query :as media-query]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [tilakone.core :as tk]))

(rf/reg-event-fx ::navigate-to-path
  (fn [_ [_ path]]
    {:navigate-to path}))

(defn render-phase-button
  "Renders a clickable button to change phase"
  [{:keys [on-click title tr current? enabled? done? errors? icon href]}]
  [:div.relative.flex.items-center (merge {:class [(when-not enabled? "opacity-25")
                                                   (when current? "phase-button--arrow")]}
                                          (when-not enabled? {:aria-disabled true}))
   (cc/icon {:icon        icon
             :description title
             :fill        "currentcolor"
             :class-name  ""
             :aria-hidden true})
   [:button.ml-3.px-0.uppercase.font-bold.border-0.bg-transparent.text-lg.cursor-pointer.hover:link-hover.rounded-none.flex.gap-2
    {:data-cy  "change-phase-btn"
     :class    [(cond current? "text-gray-900 disabled cursor-not-allowed pointer-events-none"
                      enabled? "text-blue-600"
                      :else "text-gray-900 disabled cursor-not-allowed pointer-events-none")]
     :on-click (when enabled? on-click)}
    [:span.flex.gap-x-2.items-center
     title
     (when href
       (cc/icon {:icon        i/link
                 :description (tr [:phase-indicator/link-to-other-ws])
                 :fill        "currentcolor"}))]]
   [:div.absolute.top-0.right-0
    (when done? (cc/icon {:icon        i/check
                          :description (tr [:done])
                          :fill        "currentcolor"
                          :class-name  "absolute phase-icon__done"}))
    (when errors?
      [:i.absolute.block.bg-red-500.w-2.h-2.rounded-full
       {:class      "phase-icon__errors"
        :aria-label (tr [:error/error])}])]])


(defn render-phase-indicator-phase
  "Renders a single item to the case navigation bar"
  [on-click count current-phase-index tr {:keys [index title enabled? icon done? errors? href]}]
  (let [last? (= index (- count 1))]
    [:<> {:key title}
     [render-phase-button (util/mmap {:on-click #(when enabled?
                                                   (if href
                                                     (>evt [::navigate-to-path href])
                                                     (on-click index)))
                                      :current? (= current-phase-index index)}
                                     title tr enabled? done? errors? icon href)]
     (when-not last? [:div.relative.mx-4.flex.items-center
                      (cc/icon {:icon        i/chevron-right
                                :description (tr [:application/next-phase])
                                :fill        "currentcolor"})])]))

(defn mobile-phase-indicator
  [{:keys [on-click current-phase-index tr phases]}]
  [:div.bg-white.px-4.pt-4.pb-1
   (when (> (count phases) 1)
     [ui-select/select {:id              "phase-select"
                        :class-name      "full-width-select"
                        :allow-empty?    false
                        :values          phases
                        :value           (nth phases current-phase-index)
                        :val->str        :title
                        :label-text      (tr [:workspace/phase])
                        :disabled-values (set (remove :enabled? phases))
                        :on-change       #(on-click (:index %))}])])

(defn current-step-selector [{:keys [tr current-step direct-transitions current-child]}]
  [:div {:class   (str "mr-4 ml-4 " (ws-util/workspace-emphasis current-step))
         :data-cy "current-step-selector"}
   (if (seq direct-transitions)
     [ui-select/select
      {:id           "state-selector"
       :class        "w-full"
       :values       (->> direct-transitions
                          (map (fn [{on    ::tk/on
                                     :keys [to-domain-state confirm?]}]
                                 {:name     to-domain-state
                                  :signal   on
                                  :confirm? confirm?}))
                          (cons {:name current-step}))
       :val->str     (comp tr vector :name)
       :on-change    #(primary-actions/handle-action
                        {:signal-id      (:signal %)
                         :confirm?       (:confirm? %)
                         :process-target current-child})
       :value        current-step
       :allow-empty? false
       :required     true}]
     (tr [current-step]))])

(defn render-phase-step-indicator
  "Renders the 'Current step' bar just below the phase indicator"
  [{:keys [tr loading? direct-transitions current-child]}
   {:keys [current-step current-index steps-count next-step]}]
  [:div.relative.sm:px-8.py-4.bg-white.rounded-b.border.border-ui-dark-gray.border-solid.border-t-0
   (if loading?
     (cc/progress-indicator-skeleton)
     [:div.flex.items-center.uppercase.flex-col.md:flex-row
      [:div.flex.justify-center.items-center.mb-2.md:mb-0
       [:div.mr-1 (tr [:application/current-step]) ": "]
       [current-step-selector (util/mmap direct-transitions current-step tr current-child)]]
      [:div.flex.justify-center.mb-2.md:mb-0 [:div.mr-1.font-bold.text-lg current-index]
       [:div.mr-1.font-bold.text-lg.fit-content "/"]
       [:div.mr-4.font-bold.text-lg  steps-count]]
      (when (some? next-step)
        [:div {:data-cy "next-step-selector"}
         (str (tr [:application/next-step]) ": " (tr [next-step]))])])])

(defn render-phase-indicator
  "Renders the workspace navigation bar"
  [on-click
   {:keys [tr loading? phases current-phase-index current-child]}
   phase-step-state
   direct-transitions]
  [:<>
   (if (<sub [::media-query/breakpoint-matches? :sm])
     [:div.px-8.py-5.flex.bg-ui-gray.rounded-t.border.border-ui-dark-gray.border-solid.border-b-0
      (map (partial render-phase-indicator-phase on-click (count phases) current-phase-index tr) phases)]
     [mobile-phase-indicator (util/mmap on-click current-phase-index tr phases)])
   [render-phase-step-indicator
    (util/mmap tr loading? direct-transitions current-child)
    phase-step-state]])
